import { render, staticRenderFns } from "./legalissuesfaq.vue?vue&type=template&id=8fc07ffa&scoped=true&"
import script from "./legalissuesfaq.vue?vue&type=script&lang=js&"
export * from "./legalissuesfaq.vue?vue&type=script&lang=js&"
import style0 from "./legalissuesfaq.vue?vue&type=style&index=0&id=8fc07ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc07ffa",
  null
  
)

export default component.exports